<template>
  <div class="passport-sdk">
    <div class="passport-sdk-header">
      <a class="x" @click="closeAsidePopup" href="javascript:;"></a>
    </div>
    <div class="passport-sdk-menu">
      <div class="user-info">
        <div class="user-icon">
          <img src="../../assets/image/37games-logo.png" alt="用户图标" />
        </div>
        <div class="user-id">
          <div class="titk-id">{{ userName }}</div>
          <div class="uid-id" v-if="userId">(UID: {{ userId }})</div>
        </div>
      </div>
      <div class="menu-list">
        <div class="menu-item" @click="handleFeedback">
          <div class="item-icon feedback-icon"></div>
          <div class="item-text">{{ letter.feedback || 'フィードバック' }}</div>
          <div class="item-arrow">&gt;</div>
        </div>
        <div class="menu-item" v-if="useExchange" @click="handleGiftCode">
          <div class="item-icon gift-icon"></div>
          <div class="item-text">
            {{ letter.exchange || 'ギフトコード交換' }}
          </div>
          <div class="item-arrow">&gt;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import globalConfig from '../../utiles/globalConfig'
import host from '../../config/host'
import {
  getGlobalGetGotoLink,
  getGlobalGetLinkParams
} from '../../utiles/globalGetLink'
const mainHost = globalConfig.getMainHost()

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'lang',
      'gameId',
      'serverId',
      'roleId',
      'roleName',
      'userId',
      'userName',
      'passportToken'
    ]),
    letter() {
      return this.$store.getters.letter
    },
    useExchange() {
      return [209].includes(+this.gameId)
    },
    linkParams() {
      return {
        devicePlate: 'pc',
        plat: 'pc',
        h5: 1,
        m: 1,
        web: 1,
        gameId: this.gameId,
        serverId: this.serverId,
        userId: this.userId,
        roleName: this.roleName,
        roleId: this.roleId,
        loginAccount: this.userName,
        language: this.lang,
        appLanguage: this.lang,
        uid: this.userId,
        userName: this.userName,
        packageName:
          globalConfig.getHrefParam('packageName') ||
          window.pageInfo.packageName,
        pt: globalConfig.getHrefParam('pt'), // 平台参数
        passportToken: this.passportToken
      }
    }
  },
  methods: {
    closeAsidePopup() {
      this.$store.commit('updateAsidePopupState', false)
    },
    handleFeedback() {
      this.$store.commit('updateAsideCustomerPageState', {
        visible: true,
        link: getGlobalGetGotoLink({
          link: globalConfig.hrefAddParams(
            `//${host.global.abres}${mainHost}/platform/officialSupport.html`,
            {
              ...this.linkParams
            }
          )
        })
      })
    },
    handleGiftCode() {
      this.$store.commit('updateAsideCustomerPageState', {
        visible: true,
        link: getGlobalGetGotoLink({
          link: globalConfig.hrefAddParams(
            `//gevents.${mainHost}/globalexchange/indexm.html`,
            {
              ...this.linkParams
            }
          )
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_dimen';
.passport-sdk {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f5f5;
  &-header {
    height: 54vh;
    width: 100%;
    background-color: white;
    font-size: 0;
    margin: 0;
    position: relative;
    .x {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      text-decoration: none;
      &:hover {
        cursor: pointer;
      }
    }
    .x {
      background: url($img + 'aside-close.png') no-repeat center center;
      background-size: contain;
      width: 54vh;
      height: 54vh;
      right: 0;
    }
  }
  &-menu {
    height: calc(100% - 54vh);
    overflow-y: auto;

    .user-info {
      display: flex;
      align-items: center;
      padding: 15px;
      background-color: white;
      margin-bottom: 10px;

      .user-icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 15px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .user-id {
        flex: 1;

        .titk-id {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          margin-bottom: 5px;
        }

        .uid-id {
          font-size: 14px;
          color: #999;
        }
      }
    }

    .menu-list {
      background-color: white;

      .menu-item {
        display: flex;
        align-items: center;
        padding: 15px;
        border-bottom: 1px solid #eee;

        &:last-child {
          border-bottom: none;
        }

        .item-icon {
          width: 24px;
          height: 24px;
          margin-right: 15px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

        .feedback-icon {
          background-image: url($img + 'tiktok-support.png');
        }

        .gift-icon {
          background-image: url($img + 'tiktok-exchange.png');
        }

        .item-text {
          flex: 1;
          font-size: 16px;
          color: #333;
        }

        .item-arrow {
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #999;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
